import React from 'react'
import { useMutation } from '@apollo/react-hooks'
import { Link } from "react-router-dom"
import gql from 'graphql-tag'
import { Pane, Button } from 'evergreen-ui'
import _ from 'lodash'
import SmallCard from '@bit/krzysztofsikorski.components.small-card'

const CREATE_DOCS = gql`
  mutation CreateDoc($data: String!) {
    createDoc(data: $data)
  }
`;
export default ({ docs }) => {
  const [createDocs] = useMutation(CREATE_DOCS);
  return <Pane>
    {docs.map(type => {
      const { data, _id } = type
      const { name } = JSON.parse(data)
      return <SmallCard key={_id}>
        <Pane fontWeight='800'>{name}</Pane>
        <Pane>
          <Pane>
            <Link to={'/docs/' + _id}>
              <i data-eva='edit-outline' data-eva-fill='white' />
            </Link>
          </Pane>
          <Pane style={{ marginTop: 8, cursor: 'pointer' }} onClick={() => {
            window.localStorage.setItem('activeDocs', _id)
            window.location.assign('/')
          }}>
            <i data-eva='external-link-outline' data-eva-fill='white' />
          </Pane>
        </Pane>
      </SmallCard>
    })}
    <Button iconBefore="plus" height={40} marginTop='16px' onClick={() => {
      const docsData = JSON.stringify({
        name: 'Test'
      })
      createDocs({ variables: { data: docsData }, refetchQueries: ['Docs'] })
    }}>Nowa aplikacja</Button>
  </Pane>
}


